// src/routes/PremiumRoute.tsx
import React from 'react';
import { useAuth } from '../context/AuthContext';
import { ArrowUp, Sparkles } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface PremiumRouteProps {
  children: React.ReactNode;
}

export const PremiumRoute: React.FC<PremiumRouteProps> = ({ children }) => {
  const { hasSubscription, isTrial, loading } = useAuth();
  const navigate = useNavigate();

  console.log('PremiumRoute: Checking state - hasSubscription:', hasSubscription, 'isTrial:', isTrial);

  // IMPORTANT: Check for debug mode first
  if (localStorage.getItem('debug_mode') === 'true') {
    console.log('PremiumRoute: Debug mode active, bypassing checks');
    return <>{children}</>;
  }

  if (loading) {
    console.log('PremiumRoute: Still loading, showing spinner');
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  // If user has a subscription, show the premium content
  if (hasSubscription) {
    console.log('PremiumRoute: User has subscription, showing premium content');
    return <>{children}</>;
  }

  // If user is on trial, show upgrade message
  console.log('PremiumRoute: User doesn\'t have subscription, showing upgrade message');
  return (
    <div className="flex flex-col items-center justify-center p-8 h-full">
      <div className="glass-card border border-gray-300/50 bg-white/30 backdrop-blur-[100px] shadow-lg rounded-3xl p-8 max-w-xl text-center">
        <Sparkles className="mx-auto text-primary-500 mb-6" size={48} />
        <h2 className="text-2xl font-bold mb-4">Premium Feature</h2>
        <p className="text-gray-700 mb-6">
          AI Trading Coach analysis is only available to premium subscribers. Upgrade now to unlock powerful AI-powered insights for your trading!
        </p>
        <button
          onClick={() => {
            console.log('PremiumRoute: Navigating to /pricing');
            navigate('/pricing');
          }}
          className="inline-block !rounded-full px-8 py-3 text-lg font-medium shadow-md hover:shadow-lg transition-all duration-300 bg-black hover:bg-gray-900 text-white"
        >
          Upgrade to Premium
          <ArrowUp size={18} className="ml-2 inline-block" />
        </button>
      </div>
    </div>
  );
};

export default PremiumRoute;